import { Container } from '@/components/Elements';
import { useParams } from 'react-router-dom';
import { Head } from '@/components/Head';
import { Row, Col, Alert, Flex, Button } from 'antd';
import OnboardHeader from '../components/OnboardHeader';

import styles from '../styles/layout.module.scss';
import Paragraph from 'antd/es/typography/Paragraph';
import { useResendLeadVerifyEmailMutation } from '../api/onboardAPI';
import { displayError, displaySuccess } from '@/utils/displayMessageUtils';

const ThankYou = () => {
  const { id } = useParams();
  const [resendVerifyEmail, { isLoading }] = useResendLeadVerifyEmailMutation();

  const handleResendVerifyEmail = () => {
    if (id) {
      resendVerifyEmail({ id })
        .unwrap()
        .then((res) => {
          displaySuccess(res.data.message);
        })
        .catch((err) => {
          displayError(err);
        });
    }
  };

  return (
    <div className={styles.onboardContainer}>
      <Head title="Thank You" />
      <OnboardHeader />
      <div style={{ padding: '1rem 0' }}>
        <Container>
          <Row align="middle" gutter={30}>
            <Col xs={24} md={24}>
              <Alert
                message="Thank You"
                description="A verification link has been sent to your email. Please click the link to verify and continue the process."
                type="success"
                showIcon
              />
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={24}>
              <Flex align="center" style={{ marginTop: '1rem' }}>
                <Paragraph style={{ margin: '0' }}>
                  Didn't receive the verification email? Check your spam folder
                  or try resending it.
                </Paragraph>
                <Button
                  disabled={isLoading}
                  loading={isLoading}
                  type="link"
                  onClick={handleResendVerifyEmail}
                >
                  Resend
                </Button>
              </Flex>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ThankYou;
